import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { MCommonListModalRequest, SharedPrefrences } from 'src/app/utils/utils.service';
import { lastValueFrom } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { MExtraProduct, MGetProductRequest, MGetProductResponse, MProductModal } from '../product/product.module';
import jQuery from 'jquery';
import { WsCheckoutService } from 'src/app/ws/wsCheckout/ws-checkout.service';
import { MBrandTypeMappingRequest } from './product-detail-updated.module';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
declare var $: any

@Component({
  selector: 'app-product-detail-updated',
  templateUrl: './product-detail-updated.component.html',
  styleUrls: ['./product-detail-updated.component.scss']
})

export class ProductDetailUpdatedComponent {
  mGetProductResponse: any = new MGetProductResponse();
  colorSlider: OwlOptions = {
    nav: true,
    autoplay: true,
    loop: true,
    margin: 5,
    dots: false,
    navText: [
      '<span><img src="assets/images/Caret right.svg" alt="icon" /></span>',
      '<span><img src="assets/images/Caret left.svg" alt="icon" /></span>',
    ],
    responsive: {
      0: {
        items: 6
      },
      576: {
        items: 4,
      },
      992: {
        items: 6,
      },
      1600: {
        items: 6,
      }
    },
  };

  state: any;
  mProductModal: MProductModal = new MProductModal();
  productSizes: any = [];
  productAdded: any;
  selectedIconValue: any;
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: MAddUpdateCartModuleResponse = new MAddUpdateCartModuleResponse()
  showTab: number = 1;
  mGetProductRequest: MGetProductRequest = new MGetProductRequest()
  mBrandTypeMappingRequest: MBrandTypeMappingRequest = new MBrandTypeMappingRequest()
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    items: 1,
    nav: false,
    dots: false,
    margin: 10,
  }
  mWishlistData: any = [];
  type: any;
  presentWishlist: boolean = false;
  selectedProductExtra: MExtraProduct = new MExtraProduct()
  colorList: any = [];
  firstProductImage: any;
  activeColorId: any;
  productId: any;
  selectedSize: any;
  discountList: any = [];
  websiteconfigurations: any = [];
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  highLights: any = [];
  recommends: any = [];
  productReviews: any = [];
  productReviewData: any = null;
  categoryId: any;
  brandId: any;
  categoryProductList: any = [];
  brandProductList: any = [];
  brandName: any = '';
  website_product_configuration: any;
  reviewPercent: any = 0;
  fiveRatingPercent: any = 0;
  fourRatingPercent: any = 0;
  threeRatingPercent: any = 0;
  twoRatingPercent: any = 0;
  oneRatingPercent: any = 0;
  stroke: any = '0,100';
  reviewValue: any = 0;
  userId: any;
  colorImage: boolean = false;
  colorImageChange: any = [];
  matchingImage: any = [];
  descriptionOrHowToUseActive: any = 'description'
  selectedRating: any = 5;
  userData: any;
  reviewForm: FormGroup;
  myReview: any;
  isMobile: boolean = false;
  isLoading: boolean = false;
  review: any;
  @ViewChild('brandProduct') brandProduct!: ElementRef;
  @ViewChild('similarProduct') similarProduct!: ElementRef;
  showBrandLeftArrow: boolean = true;
  showBrandRightArrow: boolean = true;
  showSimilarLeftArrow: boolean = true;
  showSimilarRightArrow: boolean = true;
  discountApplied: number = 0;

  get r() {
    return this.reviewForm.controls;
  }
  constructor(private formBuilder: FormBuilder, private fb: FormBuilder, private toast: ToastrService,
    private wsCheckoutService: WsCheckoutService, private modalService: NgbModal,
    private wsShopAllService: WsShopallService, private activatedRoute: ActivatedRoute,
    private router: Router, private _commonBehaviorChangeService: CommonBehaviorChangeService,
    private location: Location) {

    this.reviewForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });

    this.activatedRoute.params.subscribe(params => {
      this.productId = params['productId']
    })

    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === this.productId })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = parseInt("" + this.mAddUpdateCartModuleResponse.data[cart].qty);
      } else {
        this.mAddUpdateCartModule.qty = 1
      }
    })
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
        this.categoryProductList && this.categoryProductList.length > 0 && this.categoryProductList.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          } else {
            product.cartQty = null;
          }
        })
        this.brandProductList && this.brandProductList.length > 0 && this.brandProductList.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          } else {
            product.cartQty = null;
          }
        })
      } else {
        this.categoryProductList && this.categoryProductList.length > 0 && this.categoryProductList.forEach((product: any) => {
          product.cartQty = null;
        })
        this.brandProductList && this.brandProductList.length > 0 && this.brandProductList.forEach((product: any) => {
          product.cartQty = null;
        })
      }
    })
    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })
  }



  customerSlider: OwlOptions = {
    loop: false,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    dots: false,
    nav: false,
    items: 1,
    responsive: {
      0: {
        items: 1,
        margin: 10,
      }
    }
  }

  offersSlider: OwlOptions = {
    loop: false,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    dots: true,
    nav: false,
    items: 1,
    responsive: {
      0: {
        items: 1,
        margin: 10,
      }
    }
  }
  title: any = '';
  description: any = ''
  shopSlider: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    dots: false,
    center: false,
    nav: false,
    navText: [
      '<span><img src="assets/images/Caret right.svg" alt="icon" /></span>',
      '<span><img src="assets/images/Caret left.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 2,
        margin: 15,
      },
      576: {
        items: 2,
        margin: 15,
      },
      768: {
        items: 2.5,
        margin: 20,
      },
      992: {
        nav: true,
      },
      1024: {
        items: 3.5,
        margin: 30,
        nav: true,
      },
      1250: {
        items: 4.5,
        margin: 30,
        nav: true,
      },
      1600: {
        items: 4.5,
        margin: 30,
        nav: true,
      }
    }
  }
  scroll() {
    if (this.isMobile) {
      var ele = document.getElementById('home-tab-description')!;
      const yOffset = -100;
      const y = ele.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    else {
      var ele = document.getElementById('recommenddetailnew')!;
      if (this.highLights && this.highLights.length && this.recommends.length > 0) {
        const yOffset = -100;
        const y = ele.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });

      }
      else {
        window.scrollTo(ele.offsetLeft, ele.offsetTop - 200);
      }
    }
  }
  recommendation() {
    if (this.isMobile) {
      var ele = document.getElementById('home-tab')!;
      window.scrollTo(ele.offsetLeft, ele.offsetTop);
    }
    else {
      var ele = document.getElementById('f-recommendation')!;
      window.scrollTo(ele.offsetLeft, ele.offsetTop - 200);
    }
  }


  mRecommendation() {
    if (this.isMobile) {
      var ele = document.getElementById('foy-recommends')!;
      window.scrollTo(ele.offsetLeft, ele.offsetTop - 150);
    }
    else {
      var ele = document.getElementById('f-recommendation')!;
      window.scrollTo(ele.offsetLeft, ele.offsetTop);
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 991;
  }

  ngOnInit() {
    this.checkScreenSize();
    setTimeout(() => {
      this.checkAllArrow()
    }, 10000);
    this.mAddUpdateCartModule.qty = 1
    this.userId = SharedPrefrences.getUserId()
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.getAllCartProducts();
    }

    this.getProductById()
    this.getAllDiscount()
    this.getAllProductReviews()
    this.getAllWebsiteconfigurations()

  }
  productThumbnailClick(index: number) {
    $('.img-thumbnail').removeClass('active')
    $('#productThumbImage_' + index).addClass('active')
    $('.carousel-item').removeClass('active')
    $('#productImage_' + index).addClass('active')

  }
  async clickProductSize(extra: MExtraProduct) {
    this.selectedProductExtra = extra
    this.selectedSize = this.selectedProductExtra.id
    this.colorList = []
    const colors = this.selectedProductExtra.color_list;
    if (colors && colors.length > 0) {
      await colors.forEach((element: any) => {
        if (element.color != null && element.color != '' && element.color != undefined) {
          this.colorList.push(element)
        }
      });
      this.activeColorId = this.colorList[0].id
      this.selectedProductExtra = this.colorList[0]
      this.selectColor(this.colorList[0])
    } else {
      this.matchingImage = this.mProductModal.imageList.filter((image: any) => image.skucode === this.selectedProductExtra.sku);
      if (this.matchingImage && this.matchingImage.length > 0 && this.matchingImage != null && this.matchingImage != "null") {
        this.colorImageChange = this.matchingImage;
      } else {
        this.colorImageChange = this.mProductModal.imageList;
      }
      setTimeout(async () => {
        this.productThumbnailClick(0)
      }, 500);
    }
  }
  /**
  * Date: 10-06-23
  * Method : This method is used to get all cart items
  */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
        const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === this.productId })
        if (cart > -1) {
          this.mAddUpdateCartModule.qty = parseInt("" + this.mAddUpdateCartModuleResponse.data[cart].qty);
        } else {
          this.mAddUpdateCartModule.qty = 1
        }
      } else {
      }
    })
  }

  setDateFormat(date: any) {
    return moment(new Date(date)).format('DD/MM/YYYY')
  }

  changeCartItem(e: any, product: any) {
  }

  addCartItem() {
    this.mAddUpdateCartModule.qty++
  }

  removeCartItem() {
    if (this.mAddUpdateCartModule.qty > 1) {
      this.mAddUpdateCartModule.qty--
    }
  }

  async addtoCart(product: any, type: any, buynow?: any) {
    this.type = type;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product, buynow)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.productType = true;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.userId = SharedPrefrences.getUserId();
          this.addToCartCommon(product, buynow)
        }
      })
    }
  }

  async addToCartCommon(product: any, buynow?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = this.selectedProductExtra.id;
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === this.productId })
      if (cart > -1) {
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
          this._commonBehaviorChangeService.getToast('Product added to cart successfully');
          if (buynow) {
            this.buyNow(product)
          }
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      this.mAddUpdateCartModule.iswishlistitem = this.presentWishlist ? false : true;
      if (this.presentWishlist) {
        const wishlist = this.mWishlistData != null && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === this.productId })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
      this.mAddUpdateCartModule.qty = this.presentWishlist ? 0 : 1;

      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.presentWishlist = this.presentWishlist ? false : true
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  showTabContent(val: any) {
    this.showTab = val
  }

  backClick() {
    this.location.back();
  }

  /**
   * Date: 10-06-23
   * Method: This method is used to get all product by parameter passed
   */
  async getProductById() {
    this.mGetProductRequest.product_id = this.productId
    const addProductClick = this.wsShopAllService.addProductClickCount(this.productId)
    await lastValueFrom(addProductClick).then(async res => {
    })

    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(this.mGetProductRequest)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      this.mProductModal = response.data[0];
      this.brandId = "" + this.mProductModal.brand_id;
      this.categoryId = "" + this.mProductModal.category_id;
      this.brandName = this.mProductModal.brand != null ? this.mProductModal.brand.name : '';
      this.getBrandProductByParameters();
      this.getCategoryProductByParameters();
      this.getAllBrandTypeHighlight();
      this.getAllBrandTypeRecommend();
      const extras = this.mProductModal.extras;
      this.productSizes = extras && extras[0].size.split(',');
      const productId = this.productId;
      if (this.mWishlistData.length > 0) {
        const present = this.mWishlistData != null && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === productId })

        if (present > -1) {
          this.presentWishlist = true;
        }
      }
      this.colorList = []
      this.selectedProductExtra = extras[0]
      this.selectedSize = this.selectedProductExtra.id
      const colors = this.selectedProductExtra['color_list'];
      if (colors && colors.length > 0) {
        await colors.forEach((element: any) => {
          if (element.color != null && element.color != '' && element.color != undefined) {
            this.colorList.push(element)
          }
        });
        if (this.colorList.length > 0) {
          this.activeColorId = this.colorList[0].id
        }
      }
      if (this.selectedProductExtra && this.selectedProductExtra.color_list && this.selectedProductExtra.color_list.length > 0) {
        this.selectColor(this.selectedProductExtra.color_list[0])
      } else {
        this.clickProductSize(this.selectedProductExtra)
      }
      this.selectedProductExtra.color_name = this.colorList && this.colorList.length > 0 ? this.colorList[0].color_name : ''
      this.selectedProductExtra.color = this.colorList && this.colorList.length > 0 ? this.colorList[0].color : ''
      setTimeout(async () => {
        this.productThumbnailClick(0)
        document.getElementById('description') ? document.getElementById('description')!.innerHTML = this.mProductModal.description ? this.mProductModal.description : "" : null
        document.getElementById('how_to_use_it') ? document.getElementById('how_to_use_it')!.innerHTML = this.mProductModal.how_to_use_it ? this.mProductModal.how_to_use_it : "" : null
        document.getElementById('features_and_benifits') ? document.getElementById('features_and_benifits')!.innerHTML = this.mProductModal.benifits ? this.mProductModal.benifits : "" : null

        document.getElementById('mob_description') ? document.getElementById('mob_description')!.innerHTML = this.mProductModal.description ? this.mProductModal.description : "" : null
        document.getElementById('mob_how_to_use_it') ? document.getElementById('mob_how_to_use_it')!.innerHTML = this.mProductModal.how_to_use_it ? this.mProductModal.how_to_use_it : "" : null
        document.getElementById('mob_features_and_benifits') ? document.getElementById('mob_features_and_benifits')!.innerHTML = this.mProductModal.benifits ? this.mProductModal.benifits : "" : null
        $("#product_" + this.selectedProductExtra.id).attr('checked', 'checked');
      }, 500);
    })
  }

  selectColor(color: any, val?: any) {
    if (color == '') {
      return
    }

    this.activeColorId = color.id
    this.selectedProductExtra = color;
    if (!val) {
      this.matchingImage = this.mProductModal.imageList.filter((image: any) => image.skucode === color.sku);
      if (this.matchingImage && this.matchingImage.length > 0 && this.matchingImage != null && this.matchingImage != "null") {
        this.colorImageChange = this.matchingImage;
      } else {
        this.colorImageChange = this.mProductModal.imageList;
      }
      setTimeout(async () => {
        this.productThumbnailClick(0)
      }, 500);
    }
  }
  buyNowCommon(product: any) {
    const productDetail = {
      qty: this.mAddUpdateCartModule.qty,
      productId: this.selectedProductExtra && this.selectedProductExtra.id ? this.selectedProductExtra.id : product.id,
      price: this.selectedProductExtra && this.selectedProductExtra.your_price ? this.selectedProductExtra.your_price : product.your_price
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + productDetail.productId])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + productDetail.productId])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  async getAllDiscount() {
    const getAllDiscount = this.wsCheckoutService.getAllDiscountByProductId(this.productId)
    await lastValueFrom(getAllDiscount).then(async response => {
      if (response && response.statusCode == 200) {
        this.discountList = []
        await response['data'].forEach((discount: any) => {
          if (discount && discount.discounts.length > 0) {
            this.discountList = [...this.discountList, ...discount.discounts]
          }
        })
      }
    });
  }

  async getAllBrandTypeHighlight() {
    var input = {
      brand_Ids: "" + this.brandId,
      type: 'highlights'
    }

    this.highLights = []
    const getAllBrandTypeHighlight = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeHighlight).then(async response => {
      if (response && response.statusCode == 200) {
        this.highLights = response.data;
        this.getAllProductTypeHighlight()
      }
    });
  }

  async getAllProductTypeHighlight() {
    var input = {
      product_ids: "" + this.productId,
      type: 'highlights'
    }
    const getAllBrandTypeHighlight = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeHighlight).then(async response => {
      if (response && response.statusCode == 200) {
        this.highLights = [...this.highLights, ...response.data];
        this.getAllCategoryTypeHighlight();
      }
    });
  }

  async getAllCategoryTypeHighlight() {
    var input = {
      category_ids: "" + this.categoryId,
      type: 'highlights'
    }
    const getAllBrandTypeHighlight = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeHighlight).then(async response => {
      if (response && response.statusCode == 200) {
        this.highLights = [...this.highLights, ...response.data];
      }
    });
  }

  async getAllBrandTypeRecommend() {
    var input = {
      brand_Ids: "" + this.brandId,
      type: 'recommend'
    }
    this.recommends = []
    const getAllBrandTypeRecommend = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeRecommend).then(async response => {
      if (response && response.statusCode == 200) {
        this.recommends = response.data;
        this.getAllProductTypeRecommend()
      }
    });
  }


  async getAllProductTypeRecommend() {
    var input = {
      product_ids: "" + this.productId,
      type: 'recommend'
    }
    const getAllBrandTypeRecommend = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeRecommend).then(async response => {
      if (response && response.statusCode == 200) {
        this.recommends = [...this.recommends, ...response.data];
        this.getAllCategoryTypeRecommend()
      }
    });
  }

  async getAllCategoryTypeRecommend() {
    var input = {
      category_ids: "" + this.categoryId,
      type: 'recommend'
    }
    const getAllBrandTypeRecommend = this.wsCheckoutService.getAllBrandTypeMappingByProductId(input)
    await lastValueFrom(getAllBrandTypeRecommend).then(async response => {
      if (response && response.statusCode == 200) {
        this.recommends = [...this.recommends, ...response.data];
      }
    });
  }

  async getAllWebsiteconfigurations() {
    const getAllWebsiteconfigurations = this.wsShopAllService.getAllWebsiteconfigurations(this.mCommonListModalRequest)
    await lastValueFrom(getAllWebsiteconfigurations).then(async response => {
      if (response && response.statusCode == 200) {
        this.websiteconfigurations = []
        this.websiteconfigurations = response['data']
        this.websiteconfigurations.forEach((wc: any) => {
          if (wc.configurationskey == 'website_product_configuration') {
            this.website_product_configuration = JSON.parse(wc.configurationsvalue)
          }
        })
      }
    });
  }
  async getAllProductReviews() {
    this.mCommonListModalRequest.search = 'Product_Id = ' + this.productId;
    const getAllProductReviews = this.wsShopAllService.getAllProductReviews(this.mCommonListModalRequest)
    await lastValueFrom(getAllProductReviews).then(async response => {
      if (response && response.statusCode == 200) {
        this.productReviews = response.data;
        this.getProductReviewByProductId();
      }
    });
  }

  async getProductReviewByProductId() {
    const getProductReviewByProductId = this.wsShopAllService.getProductReviewByProductId(this.productId)
    await lastValueFrom(getProductReviewByProductId).then(async response => {
      if (response && response.statusCode == 200) {
        this.productReviewData = response.data;
        this.fiveRatingPercent = this.productReviewData.five_rating == 0 ? 0 : (this.productReviewData.five_rating * 100) / this.productReviewData.total_reviews
        this.fourRatingPercent = this.productReviewData.four_rating == 0 ? 0 : (this.productReviewData.four_rating * 100) / this.productReviewData.total_reviews
        this.threeRatingPercent = this.productReviewData.three_rating == 0 ? 0 : (this.productReviewData.three_rating * 100) / this.productReviewData.total_reviews
        this.twoRatingPercent = this.productReviewData.two_rating == 0 ? 0 : (this.productReviewData.two_rating * 100) / this.productReviewData.total_reviews
        this.oneRatingPercent = this.productReviewData.one_rating == 0 ? 0 : (this.productReviewData.one_rating * 100) / this.productReviewData.total_reviews
        var fiveRating = this.productReviewData.five_rating == 0 ? 0 : this.productReviewData.five_rating * 5;
        var fourRating = this.productReviewData.four_rating == 0 ? 0 : this.productReviewData.four_rating * 4;
        var threeRating = this.productReviewData.three_rating == 0 ? 0 : this.productReviewData.three_rating * 3;
        var twoRating = this.productReviewData.two_rating == 0 ? 0 : this.productReviewData.two_rating * 2;
        var oneRating = this.productReviewData.one_rating == 0 ? 0 : this.productReviewData.one_rating * 1;
        var totalRating = fiveRating + fourRating + threeRating + twoRating + oneRating;
        this.reviewValue = totalRating == 0 ? 0 : Math.ceil((totalRating) / this.productReviewData.total_reviews).toFixed(1)
        this.reviewPercent = (this.reviewValue * 100) / 5
        this.stroke = this.reviewPercent + ',100'
      }
    });
  }


  async getBrandProductByParameters() {
    this.mGetProductResponse.data = []

    this.mGetProductRequest.take = 6;
    if (this.brandId && this.brandId != '') {
      this.mGetProductRequest.brand = "" + this.brandId;
    }
    const brandProduct = this.mGetProductRequest;
    delete brandProduct.product_id;

    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(brandProduct)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;

      if (this.mGetProductResponse.data && this.mGetProductResponse.data.length < 1) {
        this.mGetProductResponse.data = response.data;
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.mGetProductResponse.data = [...this.mGetProductResponse.data, ...response.data];
      }
      this.brandProductList = []
      this.brandProductList = this.mGetProductResponse.data;
    })
  }

  async getCategoryProductByParameters() {
    this.mGetProductResponse.data = [];

    this.mGetProductRequest.take = 6;
    if (this.categoryId && this.categoryId != '') {
      this.mGetProductRequest.categoryIds = "" + this.categoryId
    }
    const categoryProduct = this.mGetProductRequest;
    delete categoryProduct.product_id;
    delete categoryProduct.brand;

    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(categoryProduct)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;

      if (this.mGetProductResponse.data && this.mGetProductResponse.data.length < 1) {
        this.mGetProductResponse.data = response.data;
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.mGetProductResponse.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
              product.cartQty = this.mAddUpdateCartModuleResponse.data[cartPresent].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.mGetProductResponse.data = [...this.mGetProductResponse.data, ...response.data];
      }
      this.categoryProductList = [];
      this.categoryProductList = this.mGetProductResponse.data.filter((item: any) => item?.id != this.mProductModal?.id);
    })
  }


  viewBrandDetail() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/individual-brand/" + this.brandName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')], {
      queryParams: {
        b: (this.brandId)
      }
    })
  }

  gotoShopAll() {
    this.router.navigate(["/shop-all/" + this.brandName + '/' + this.brandId])
  }

  changeSeletion(val: any) {
    this.descriptionOrHowToUseActive = val;
  }

  gotoShopAllOfBrands() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], {
      queryParams: {
        b: this.brandId
      }
    })
  }

  gotoShopAllOfCategory() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all"], {
      queryParams: {
        c: this.categoryId
      }
    })
  }

  brandNameClick(val: any) {
    this.router.navigate(["/individual-brand/" + val.name.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')], {
      queryParams: {
        b: val.id
      }
    })
  }

  selectedRatings(val: any) {
    this.selectedRating = val;
  }

  openLoginPopup(val: any) {
    const modalRef = this.modalService.open(LoginPopupComponent);
    modalRef.componentInstance.type = 1;
    modalRef.componentInstance.productType = true;
    modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
      if (emmitedValue) {
        this.userId = SharedPrefrences.getUserId();
        this.selectedRating = val;
        $('#addreview').modal('show');
      }
    })
  }

  updateRating(val: any) {
    this.review = val
    this.selectedRating = this.review.rating;
    this.reviewForm.controls['title'].setValue(this.review.title)
    this.reviewForm.controls['description'].setValue(this.review.description)
  }

  async addProductReview() {
    if (this.reviewForm.valid) {
      this.isLoading = true;
      this.userData = JSON.parse("" + SharedPrefrences.getUserData());
      var productData = {
        "product_id": this.productId,
        "user_id": this.userData.id,
        "title": this.reviewForm.controls['title'].value,
        "description": this.reviewForm.controls['description'].value,
        "rating": this.selectedRating,
        "age": this.userData.age ? this.userData.age : 0,
        "email": this.userData.email,
        "skin_type": this.userData.skin_type ? this.userData.skin_type : "string",
        "likedProductReviewCount": 0,
        "disLikedProductReviewCount": 0,
        "username": this.userData.first_name + ' ' + this.userData.last_name,
        "created_by": this.userData.id
      }
      const addProductR = this.wsShopAllService.addProductReview(productData)
      await lastValueFrom(addProductR).then(async res => {
        this.selectedRating = null;
        document.querySelectorAll('.star-rating input[type="radio"]').forEach((star) => {
          (star as HTMLInputElement).checked = false;
        });
        this.isLoading = false;
        this.title = '';
        this.description = '';
        this.reviewForm.markAsUntouched();
        this.reviewForm.reset();
        this.reviewForm.controls['title'].setValue('');
        this.reviewForm.controls['description'].setValue('');
        $("#addreview").hide();
        $(".modal-backdrop").hide();
        this._commonBehaviorChangeService.getToast("Product Review added successfully.")
        this.getAllProductReviews()
      }, (error) => {
        this.isLoading = false;
        if (error && error.error && error.error.errors && error.error.errors.email && error.error.errors.email.length > 0) {
          this._commonBehaviorChangeService.getToast("Please add email in your profile!");
        }
      })
    }
  }

  async updateProductReviewPage() {
    if (this.reviewForm.valid) {
      this.isLoading = true;
      this.userData = JSON.parse("" + SharedPrefrences.getUserData());
      var productData = {
        "id": this.review.id,
        "product_id": this.productId,
        "user_id": this.userData.id,
        "title": this.reviewForm.controls['title'].value,
        "description": this.reviewForm.controls['description'].value,
        "rating": this.selectedRating,
        "age": this.userData.age,
        "email": this.userData.email,
        "skin_type": this.userData.skin_type ? this.userData.skin_type : "string",
        "likedProductReviewCount": 0,
        "disLikedProductReviewCount": 0,
        "username": this.userData.first_name + ' ' + this.userData.last_name,
        "created_by": this.userData.id
      }
      const addProductR = this.wsShopAllService.updateProductReviewPage(productData)
      await lastValueFrom(addProductR).then(async res => {
        this.selectedRating = null;
        document.querySelectorAll('.star-rating input[type="radio"]').forEach((star) => {
          (star as HTMLInputElement).checked = false;
        });
        this.isLoading = false;
        this.title = '';
        this.description = '';
        this.reviewForm.markAsUntouched();
        this.reviewForm.reset();
        this.reviewForm.controls['title'].setValue('');
        this.reviewForm.controls['description'].setValue('');
        $("#addreview").hide();
        $(".modal-backdrop").hide();
        this._commonBehaviorChangeService.getToast("Product Review added successfully.")
        this.getAllProductReviews()
      })
    }
  }

  async updateProductReview(productReviewId: any, like_Dislike: any) {
    var productReviewData = {
      "id": productReviewId,
      "product_review_id": productReviewId,
      "user_id": SharedPrefrences.getUserId(),
      "like_Dislike": like_Dislike,
      "modified_by": SharedPrefrences.getUserId()
    }
    const updateProductReview = this.wsShopAllService.updateProductReview(productReviewData)
    await lastValueFrom(updateProductReview).then(async response => {
      if (response) {
        this.getAllProductReviews();
      }
    })
  }

  invalidFormFunc() {
    if (this.reviewForm.invalid) {
      this.reviewForm.markAllAsTouched();
      return;
    }
  }
  closemodal() {
    this.reviewForm.markAsUntouched();
    this.reviewForm.reset();
  }

  checkAllArrow() {
    if (this.brandProduct) {
      let container = this.brandProduct.nativeElement;
      this.showBrandLeftArrow = container.scrollLeft > 0;
      this.showBrandRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
    }
    if (this.similarProduct) {
      let similarcontainer = this.similarProduct.nativeElement;
      this.showSimilarLeftArrow = similarcontainer.scrollLeft > 0;
      this.showSimilarRightArrow = similarcontainer.scrollWidth > similarcontainer.clientWidth + similarcontainer.scrollLeft;
    }
  }
  checkScroll(id: any) {
    switch (id) {
      case 'brand-product':
        let container = this.brandProduct.nativeElement;
        this.showBrandLeftArrow = container.scrollLeft > 0;
        this.showBrandRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
        break;
      case 'shop-similar-product':
        let similarcontainer = this.similarProduct.nativeElement;
        this.showSimilarLeftArrow = similarcontainer.scrollLeft > 0;
        this.showSimilarRightArrow = similarcontainer.scrollWidth > similarcontainer.clientWidth + similarcontainer.scrollLeft;
        break;

      default:
        break;
    }
  }
  goRight(id: any) {
    var container = document.getElementById(id)
    this.sideScroll(container, 'right', 10, 200, 10);
    setTimeout(() => {
      this.checkScroll(id)
    }, 2000);
  }

  goLeft(id: any) {
    var container = document.getElementById(id)
    this.sideScroll(container, 'left', 10, 200, 10);
    setTimeout(() => {
      this.checkScroll(id)
    }, 2000);
  }

  sideScroll(element: any, direction: any, speed: any, distance: any, step: any) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  getDiscountShow(val: any) {
    if(val.extras && val.extras.length > 0){
      if(this.selectedProductExtra.discountList && this.selectedProductExtra.discountList.length > 0){
        if (this.selectedProductExtra.discountList[0].amount) {
          return '₹' + this.selectedProductExtra.discountList[0].amount + 'OFF'
        } else {
          return this.selectedProductExtra.discountList[0].percentage + '% OFF'
        }
      }
      else{
        return;
      }
    }
    else{
      if (val.discountList.length > 0) {
        if (val.discountList[0].amount) {
          return '₹' + val.discountList[0].amount + 'OFF'
        } else {
          return val.discountList[0].percentage + '% OFF'
        }
      } else {
        return ;
      }
    }
  }

  getNewProductPrice(val: any){
    if(val.extras && val.extras.length > 0){
      if(this.selectedProductExtra.discountList && this.selectedProductExtra.discountList.length > 0){
        if(this.selectedProductExtra.discountList[0].amount < 1){
          if(this.selectedProductExtra.discountList && this.selectedProductExtra.discountList.length > 0){
            this.discountApplied = this.selectedProductExtra.your_price * this.selectedProductExtra.discountList[0].percentage / 100;
          }
          if (this.discountApplied > this.selectedProductExtra.your_price) {
            this.discountApplied = this.selectedProductExtra.your_price;
          }
          if (this.discountApplied > this.selectedProductExtra.discountList[0].max_amount && this.selectedProductExtra.discountList[0].max_amount > 0) {
            if (this.selectedProductExtra.discountList[0].max_amount > this.selectedProductExtra.your_price) {
              this.discountApplied = this.selectedProductExtra.your_price;
            } else {
              this.discountApplied = this.selectedProductExtra.discountList[0].max_amount;
            }
          }
        }
        if(this.selectedProductExtra.discountList[0].amount > 0){
          if(this.selectedProductExtra.your_price > this.selectedProductExtra.discountList[0].amount){
            this.discountApplied = this.selectedProductExtra.discountList[0].amount;
          }
          else{
            this.discountApplied = this.selectedProductExtra.your_price;
          }
        }
        return Math.round((this.selectedProductExtra.your_price - this.discountApplied))
      }
      else{
        this.discountApplied = 0;
      }
      return Math.round(this.selectedProductExtra.your_price)
    }
    else{
      if (val.discountList.length > 0) {
        if (val.discountList[0].amount < 1) {
          this.discountApplied = val.your_price * val.discountList[0].percentage / 100;
          if (this.discountApplied > val.your_price) {
            this.discountApplied = val.your_price;
          }
          if (this.discountApplied > val.discountList[0].max_amount && val.discountList[0].max_amount > 0) {
            if (val.discountList[0].max_amount > val.your_price) {
              this.discountApplied = val.your_price;
            } else {
              this.discountApplied = val.discountList[0].max_amount;
            }
          }
        }

        if (val.discountList[0].amount > 0) {
          if (val.your_price > val.discountList[0].amount) {
            this.discountApplied = val.discountList[0].amount;
          } else {
            this.discountApplied = val.your_price;
          }
        }
        return Math.round((val.your_price - this.discountApplied))
      } else {
        return Math.round(val.your_price)
      }
    }
    }
}
